export default {
  title: {
    add: '新增',
    editor: '编辑'
  },
  label: {
    createAcct: '创建人',
    createTime: '创建时间',
    id: '主键id',
    ipList: 'ip地址',
    merchantNo: '商户号',
    updateAcct: '更新人',
    updateTime: '更新时间',
    action: '操作',
    operator: '操作人',
  },
  rules: {
    ipList: {
      required: '请输入ip地址',
      isip: 'IP地址格式不正确'
    },
    merchantNo: {
      required: '请输入商户号'
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh/merchantip.js